import { useContext, createContext } from "react";
// hooks
import useStorage, { StorageKeys } from "../hooks/useStorage";
// services
import { config } from "@local/theme";
// types
import type { ReactElement } from "react";
const ServerOptionContext = createContext(config.serverOptions[0]!);

if (process.env.NODE_ENV !== "production") {
	ServerOptionContext.displayName = "ServerOptionContext";
}

export const useServerOption = () => (useContext(ServerOptionContext));

type Props = Readonly<{
	children: ReactElement;
}>;

export const ServerOptionProvider = ({ children }: Props) => {
	const [selectedBackendServer] = useStorage(StorageKeys.selectedBackendServer);

	const serverOption = config.serverOptions.find((serverOption) => (serverOption.id === selectedBackendServer)) ?? config.serverOptions[0]!;

	return (
		<ServerOptionContext value={serverOption}>
			{children}
		</ServerOptionContext>
	);
};
